<ng-container *ngIf="!isEditRoles">
  <span *ngFor="let role of nonAccountUserTypeRoles">
    <span class="badge badge-dark">{{ role }}</span>
  </span>
</ng-container>

<span class="d-flex flex-wrap border" *ngIf="isEditRoles">
  <ng-container *ngFor="let role of userRoles">
    <app-switch-checkbox
      [innerId]="'checkbox_userroles_' + role.code"
      *ngIf="role.type === roleTypes.User"
      [checked]="hasRole(role.code)"
      bsClass="success"
      bsSize="sm"
      (change)="onRoleChange(role.code)"
      [hoverable]="true"
      [disabled]="isUpdatingRole"
    >
      {{ role.code }}
    </app-switch-checkbox>
  </ng-container>
</span>
<span [ngbTooltip]="canEditToolTip">
  <button
    *ngIf="isEditable"
    class="btn btn-link"
    id="edit-roles-button"
    (click)="onEditRole()"
    [disabled]="!canEditRoles"
  >
    <i [ngClass]="isEditRoles ? 'fa-times' : 'fa-pencil-alt'" class="fas"></i>
    {{ isEditRoles ? 'Close' : 'Edit' }}
  </button>
</span>
